import * as yup from "yup";

const REQUIRED_MESSAGE = "This field is required";

export const userSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  userName: yup.string().required(REQUIRED_MESSAGE),
  email: yup.string().email("Enter a valid email").required(REQUIRED_MESSAGE),
  password: yup.string().when("$isEditMode", {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema.required(REQUIRED_MESSAGE).min(6, "Password must be at least 6 characters"),
  }),
  role: yup.string().required(REQUIRED_MESSAGE),
});
